import React from "react";
import PropTypes from "prop-types";
import withIntl from "../../../utils/withIntl";
import { Chip, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AuthorizationWrapper from "../../AuthorizationWrapper";
import EditSelect from "../../EditArticle/EditSelect";
import { getPrintgroupsFromStores } from "../../../store/articles/ArticlesHelpers";

const useStyles = makeStyles(() => ({
  disabledTitle: { color: "lightgray" },
  rootButton: { fontSize: 12 },
}));

function Printgroups(props) {
  const classes = useStyles();
  const printgroups = props.article.getPrintTags();

  return (
    <AuthorizationWrapper
      permission={"printgroups"}
      child={(write) => {
        return (
          <div style={{ width: "100%" }}>
            <Typography classes={{ root: props.disabled && classes.disabledTitle }}>
              {props.intl.formatMessage({ id: "print_groups" })}
            </Typography>
            <EditSelect
              helperText={
                Object.keys(getPrintgroupsFromStores()).length === 0
                  ? props.intl.formatMessage({ id: "no_print_groups" })
                  : null
              }
              fullWidth
              disabled={!write || props.disabled === true || Object.keys(getPrintgroupsFromStores()).length === 0}
              value={printgroups}
              optionValues={getPrintgroupsFromStores()}
              optionViewValues={getPrintgroupsFromStores()}
              multiple={true}
              onChange={(value) => {
                props.onChange(value);
              }}
            />
            <div style={{ margin: 5 }}>
              {printgroups.length === 0 && (
                <Chip
                  color="primary"
                  classes={{ root: classes.rootButton }}
                  label={props.intl.formatMessage({ id: "all_printers" })}
                />
              )}

              {printgroups.map((printgroup) => {
                return (
                  <Chip color="primary" key={printgroup} classes={{ root: classes.rootButton }} label={printgroup} />
                );
              })}
            </div>
          </div>
        );
      }}
    />
  );
}

Printgroups.propTypes = {
  article: PropTypes.object.isRequired,
};

export default withIntl(Printgroups);
